// extracted by mini-css-extract-plugin
module.exports = {"button":"Modal_button__gZnem","content-wrapper":"Modal_content-wrapper__jpknG"};